import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { MessageContent } from '../../models/message-content.model';

import API from '../../services/api';

import formulaKeys from './_queryKeys';

const getFormulaMessageContents = async (formulaId: number) => {
    const { data } = await API.fetchMessageContentByFormulaId(formulaId);
    return data;
};

export default function useGetFormulaMessageContents(formulaId: number) {
    return useQuery<MessageContent[], BaseError>({
        queryKey: formulaKeys.formulaMessageContents(formulaId),
        queryFn: () => getFormulaMessageContents(formulaId),
        enabled: !!formulaId,
        staleTime: 2 * 60 * 60 * 1000, // 2 hours
    });
}
